import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";

// external libraries
import { TranslateModule } from "@ngx-translate/core";

// material
import { MaterialModule } from "gematik-form-library";
import { GemComponentsModule } from "gematik-form-library";

// components
import * as fromComponents from "./components";

// containers
import * as fromContainers from "./containers";
import { NgApexchartsModule } from "ng-apexcharts";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { GemLoadingPlaceholderComponent, GemSkeletonComponent } from "gematik-shared";

export const ROUTES: Routes = [];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    ReactiveFormsModule,
    MaterialModule,
    GemComponentsModule,
    TranslateModule,
    NgApexchartsModule,
    NgbModule,
    GemSkeletonComponent,
    GemLoadingPlaceholderComponent,
  ],
  declarations: [...fromComponents.components, ...fromContainers.containers],
  providers: [],
  exports: [...fromComponents.components, ...fromContainers.containers],
})
export class SharedModule {}
